/* Remplit les dates de la frise « commande, expédition, livraison ».

   Le balisage vient du thème source et attend un élément <dynamic-dates> dont
   le script n'a jamais été repris : les dates restaient vides. On lit
   data-min-days et data-max-days sur chaque étape, on remplace [start_date] et
   [end_date] dans data-text, et on affiche une plage quand les deux diffèrent.

   Le calcul se fait sur le fuseau Europe/Paris pour qu'une commande passée le
   soir n'affiche pas la date de la veille. */
(() => {
  'use strict';

  const MOIS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin',
                'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
  const JOURS = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];

  function aujourdhui() {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(new Date());
    const n = (t) => Number(parts.find((p) => p.type === t).value);
    return new Date(Date.UTC(n('year'), n('month') - 1, n('day'), 12));
  }

  function formate(base, jours, format) {
    const d = new Date(base);
    d.setUTCDate(d.getUTCDate() + Number(jours || 0));
    const jour = d.getUTCDate();
    const mois = MOIS[d.getUTCMonth()];
    if (format === 'day_dd_mm_numeric') {
      return JOURS[d.getUTCDay()] + ' ' + jour + ' ' + mois;
    }
    return jour + ' ' + mois;
  }

  function remplir(racine) {
    if (racine.dataset.cpRempli) return;
    racine.dataset.cpRempli = 'true';
    const base = aujourdhui();
    const format = racine.dataset.dateFormat || '';

    racine.querySelectorAll('[data-dynamic-date]').forEach((e) => {
      const modele = e.dataset.text;
      if (!modele) return;
      const min = e.dataset.minDays, max = e.dataset.maxDays;
      const debut = formate(base, min, format);
      const fin = formate(base, max, format);
      let texte = modele.replace('[start_date]', debut).replace('[end_date]', fin);
      // une plage quand les deux bornes different et que le modele n'en attend qu'une
      if (min !== max && modele.indexOf('[end_date]') === -1 && modele.indexOf('[start_date]') !== -1) {
        texte = modele.replace('[start_date]', debut + ' – ' + fin);
      }
      e.innerHTML = texte;
    });
  }

  const lancer = (p = document) => p.querySelectorAll('dynamic-dates, [data-dynamic-dates]').forEach(remplir);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => lancer());
  } else {
    lancer();
  }
  document.addEventListener('shopify:section:load', (e) => lancer(e.target));
})();
